module.exports = __webpack_public_path__ + "img/check_mark.5ca0e2b8.svg";